import React, { Component } from 'react'
import { ApolloProvider } from 'react-apollo'
import PipelineLayout from './PipelineLayout'
import { client } from '../shared/ApolloClient'

class Layout extends Component {
  render() {
    return (
      <ApolloProvider client={client}>
        <PipelineLayout
          {...this.props}
        />
      </ApolloProvider>
    )
  }
}

export default Layout
